import { useMutation } from '@tanstack/react-query';

import { bnplIntentMutation } from '@/api/booking/bnplIntentMutation';

export const useBnplIntentMutation = () => useMutation(bnplIntentMutation());
